import { StaticBaseDao } from '@/dao';
import { ResultSetup } from '@/objects/generated';

export class ResultSetupDao extends StaticBaseDao {
    public static async GetResultSetupForEvent(EventID: number): Promise<ResultSetup | null> {
        return this.BaseFetch(
            ResultSetup,
            `ResultSetup/GetResultSetupForEvent` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
    public static async SaveResultSetupForEvent(resultSetup: ResultSetup, EventID: number): Promise<number | null | null> {
        return this.Post(`ResultSetup/SaveResultSetupForEvent` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), resultSetup);
    }
}
